import React from 'react';
import { oneOfType, arrayOf, node, object, string } from 'prop-types';
import classNames from 'classnames';
import './Scrollable.sass';

function Scrollable({ children = null, className = '', style = {} }) {
  return (
    <div
      style={{ ...style }}
      className={classNames('scrollable-container', className)}
    >
      <div className="scrollable-content">{children}</div>
    </div>
  );
}

Scrollable.propTypes = {
  children: oneOfType([node, arrayOf(node)]),
  style: object,
  className: string,
};

export default Scrollable;
